import { createAction, props } from '@ngrx/store';
import { IStaticDataNumberResponse } from '../models/static-data.model';

export const loadProductAnnualSwitchLimits = createAction('[StaticData] Load AnnualSwitchLimits');

export const loadProductAnnualSwitchLimitsSuccess = createAction(
  '[StaticData] Load AnnualSwitchLimits Success',
  props<{ response: IStaticDataNumberResponse[] }>()
);

export const loadProductAnnualSwitchLimitsFailure = createAction('[StaticData] Load AnnualSwitchLimits Failure', props<{ error: any }>());
